import { IconProps } from 'src/utils/icon';

const OpenArrowLeftIcon: React.FC<IconProps> = ({
  size = 1,
  fill = 'var(--white)',
}) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 7 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 9L1 5L5 1"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default OpenArrowLeftIcon;
